import type { PluginManifest, PluginOverviewCard } from '@reflex/plugin-api';

/**
 * Picks the overview card most likely to describe the plugin as a whole.
 *
 * Most plugins emit a single overview card via {@link definePage}, so the
 * default strategy is "first card". When a plugin contributes multiple
 * cards (e.g. plugin-town with `Town` and `Flow Town`), we prefer the
 * card whose label matches the plugin name so the rendered description
 * matches the page the user is looking at.
 */
export function findOverviewCardForPlugin(
  manifest: PluginManifest,
): PluginOverviewCard | undefined {
  const cards = manifest.web?.overviewCards ?? [];
  if (cards.length === 0) return undefined;
  const target = manifest.name.toLowerCase();
  const labelMatch = cards.find((c) => c.label.toLowerCase() === target);
  if (labelMatch) return labelMatch;
  // Plugin name often appears as a slash-prefixed nav target (`/leaderboard`).
  const pathMatch = cards.find(
    (c) => c.to.toLowerCase() === `/${target}` || c.to.toLowerCase() === target,
  );
  if (pathMatch) return pathMatch;
  return cards[0];
}
